import RouteError from "./RouteError";

/**
 * @constructor
 */
export default class NoTicketCodeError extends RouteError {
    constructor() {
        super('noTicketCode');
    }
}